import { CidrSheet } from './CidrSheet';

type ConfirmDialogProps = {
  title: string;
  message: string;
  cancelLabel: string;
  confirmLabel: string;
  closeLabel: string;
  danger?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ConfirmDialog({
  title,
  message,
  cancelLabel,
  confirmLabel,
  closeLabel,
  danger = false,
  onClose,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <CidrSheet title={title} closeLabel={closeLabel} onClose={onClose}>
      <p className="cidr-sheet__hint">{message}</p>
      <div className="cidr-sheet__actions">
        <button type="button" className="cidr-sheet__btn" onClick={onClose}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={`cidr-sheet__btn${danger ? ' cidr-sheet__btn--danger' : ' cidr-sheet__btn--primary'}`}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </CidrSheet>
  );
}
